import React from "react";
import { Link } from "react-router-dom"

const SideBarAdmin = ({
}) => {

    return (
        <div>
            <nav className="navbar-expand-sm bg-navbar">
                <div className="dropdown ml-2"></div>
                <div className="collapse navbar-collapse" id="sidebar">
                    <ul className="navbar-nav sidebar" id="accordionSidebar">
                        <div className="navbar-brand d-flex align-items-center justify-content-center">
                            <img src="/img/newLogoMap.png" alt="logo map" className="d-block mx-auto" style={{width:"100px",marginTop:"5px"}}/>
                        </div>
                        <div className="sidebar-heading mt-3" style={{marginTop:"10px"}}>Menu Utama</div>
                        <li className="nav-item nav-itemm my-2">
                            <Link className="nav-link nav-linkk" to={`/admin/dashboard`} style={{marginTop:"-5px"}}><i className="bi bi-columns-gap"style={{color:"rgb(106, 0, 198)"}}></i><span>Dashboard</span></Link>
                        </li>
                        <li className="nav-item nav-itemm">
                            <Link className="nav-link nav-linkk" to={`/admin/manajemen-user`} style={{marginTop:"-5px"}}><i className="bi bi-people"style={{color:"rgb(0, 181, 198)"}}></i><span>Manajemen User</span></Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default SideBarAdmin